import { useAppDispatch } from "@/reducer";
import { setPlotLocation, setPlotLocationInfo } from "@/reducer/PlotsState";
import { setTephigramLocation, setTephigramLocationInfo } from "@/reducer/TephigramState";
import { setWeatherTableLocation } from "@/reducer/WeatherTablesState";
import { type LabeledCoordinates, labeledLocationToLocationInfo } from "@/types/location";
import { useCallback } from "react";

export type ToolLocationTarget =
  | { type: "plot"; id: number }
  | { type: "weatherTable"; id: number }
  | { type: "tephigram"; id: number };

export const useApplyLocationToTool = () => {
  const dispatch = useAppDispatch();

  return useCallback(
    (target: ToolLocationTarget, location: LabeledCoordinates) => {
      const { lat, lon } = location;

      switch (target.type) {
        case "plot": {
          dispatch(setPlotLocationInfo({ id: target.id, props: labeledLocationToLocationInfo(location) }));
          dispatch(setPlotLocation({ id: target.id, props: { lat, lng: lon } }));
          break;
        }
        case "weatherTable": {
          dispatch(setWeatherTableLocation({ id: target.id, props: location }));
          break;
        }
        case "tephigram": {
          dispatch(setTephigramLocationInfo({ id: target.id, props: labeledLocationToLocationInfo(location) }));
          dispatch(setTephigramLocation({ id: target.id, props: { lat, lng: lon } }));
          break;
        }
      }
    },
    [dispatch],
  );
};
